import { freshModal } from "../freshModal";
import React, { useState } from "react";
import Modal from "./Modal";

const SendToFreelanceModalFormSession = ({
  isOpen,
  onClose,
  onSave,
  candidateId,
}) => {
  const [formData, setFormData] = useState({
    referralDate: new Date().toISOString().split("T")[0],
    jobTitle: "",
    skills: "",
    experienceLevel: "intermediaire",
    expectedRate: "",
    notes: "",
    candidateId,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Envoyer en freelance"
      className="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="referralDate"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Date d'envoi
            </label>
            <input
              type="date"
              id="referralDate"
              name="referralDate"
              required
              value={formData.referralDate}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              htmlFor="jobTitle"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Poste recherché
            </label>
            <input
              type="text"
              id="jobTitle"
              name="jobTitle"
              required
              value={formData.jobTitle}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="skills"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Compétences clés
          </label>
          <input
            type="text"
            id="skills"
            name="skills"
            required
            value={formData.skills}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ex: React, Node.js, AWS..."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="experienceLevel"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Niveau d'expérience
            </label>
            <select
              id="experienceLevel"
              name="experienceLevel"
              required
              value={formData.experienceLevel}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="junior">Junior (0-2 ans)</option>
              <option value="intermediaire">Intermédiaire (2-5 ans)</option>
              <option value="senior">Senior (5-8 ans)</option>
              <option value="expert">Expert (8+ ans)</option>
            </select>
          </div>
          <div>
            <label
              htmlFor="expectedRate"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              TJM souhaité (€)
            </label>
            <input
              type="number"
              id="expectedRate"
              name="expectedRate"
              value={formData.expectedRate}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="notes"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Notes complémentaires
          </label>
          <textarea
            id="notes"
            name="notes"
            rows={3}
            value={formData.notes}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Informations supplémentaires..."
          />
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Envoyer
          </button>
        </div>
      </form>
    </Modal>
  );
};

export const SendToFreelanceModal = freshModal(SendToFreelanceModalFormSession, "isOpen");
